import { render, staticRenderFns } from "./Engajamento.vue?vue&type=template&id=bc22ce34"
import script from "./Engajamento.vue?vue&type=script&lang=js"
export * from "./Engajamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports